$(document).ready(function(){
    var collectionLists = document.querySelectorAll('.block__collection-lists-box-slider')
            collectionLists && collectionLists.forEach(collectionListsAll => {
            new Swiper(collectionListsAll, {
                autoHeight: true,
                slidesPerView: 2,
                spaceBetween: 5,
                loop: true,
                breakpoints: {
                    370: {
                      slidesPerView: 2.5,
                      spaceBetween: 5
                    },
                    750: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1200: {
                      slidesPerView: 5,
                      spaceBetween: 20,
                      loop: false
                    },
                    1560: {
                      slidesPerView: 6,
                      spaceBetween: 20,
                      loop: false
                    }
                }
            });
        });
});